import { useContext } from "react";

import { IconArrowDown } from "@tabler/icons";

import { TableContext } from "@sso/context/tableContext";
import { SortKeys } from "@sso/types";
import { Flex, FlexProps } from "@sso/ui/FlexBox";

interface TableThWithSortIconProps extends FlexProps {
  title: string;
  column: string;
}

export const TableThWithSortIcon = ({ title, column, ...flexProps }: TableThWithSortIconProps) => {
  const { sort } = useContext(TableContext);

  const isSorted = sort?.column === column && sort.type !== SortKeys.NONE;
  const isSortedDesc = sort?.type === SortKeys.DESC;

  return (
    <Flex minHeight="20px" justify="flex-start" {...flexProps}>
      {title}
      <Flex transition="transform 0.3s" transform={`rotate(${isSortedDesc ? "180deg" : "0deg"})`}>
        <IconArrowDown size={20} visibility={isSorted ? "default" : "hidden"} />
      </Flex>
    </Flex>
  );
};
